import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-slate-300 pt-20 pb-10 border-t-4 border-accent" data-id="element-16" data-mp="3gg0xbxz0nnv0">
      <div className="max-w-7xl mx-auto px-6" data-id="element-17" data-mp="32ovuyo49khgz">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-18" data-mp="32m1d94cmxar9">
          {/* Brand */}
          <div className="flex flex-col gap-6" data-id="element-19" data-mp="36n3dnoiafsut">
            <Link to="/" className="flex items-center gap-3 group shrink-0" data-id="element-20" data-mp="3ug3f7k7bqha9">
              <video src="https://cdn.magicpatterns.com/uploads/7WxQuepNXeVvAcNAXbfhWT/kling_20260618_VIDEO_Create_a_p_561_0.mp4" autoPlay loop muted playsInline className="h-16 w-auto object-contain" data-id="element-21" data-mp="3991alritibr" />
              <div className="flex flex-col leading-none" data-id="element-22" data-mp="29yxcxcohlklt">
                <span className="font-display font-bold text-base text-white tracking-tight" data-id="element-23" data-mp="2a1jjb8zn5u2g">
                  THE ELECTRICAL
                </span>
                <span className="font-display font-bold text-base text-white tracking-tight" data-id="element-24" data-mp="3lalgfg6ys7uh">
                  PROFESSIONALS INC
                </span>
              </div>
            </Link>
            <p className="text-sm leading-relaxed" data-id="element-25" data-mp="3v7zvpch5iql7">
              Powering homes, businesses, and communities with confidence. Safe,
              dependable, and high-quality electrical solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-26" data-mp="80nvaoqub0fi">
            <h3 className="text-yellow-400 font-display font-semibold text-lg mb-6 uppercase tracking-wider" data-id="element-27" data-mp="3472hh8p3xw3">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-3" data-id="element-28" data-mp="hs1yb6i02ide">
              <li data-id="element-29" data-mp="ct75rcu8dfg3">
                <Link to="/" className="hover:text-accent transition-colors" data-id="element-30" data-mp="curzj08q0ucw">
                  Home
                </Link>
              </li>
              <li data-id="element-31" data-mp="qrfaw81f7n2c">
                <Link to="/about" className="hover:text-accent transition-colors" data-id="element-32" data-mp="mrwrjgp8zk1m">
                  About Us
                </Link>
              </li>
              <li data-id="element-33" data-mp="yty1bvsfwx5p">
                <Link to="/gallery" className="hover:text-accent transition-colors" data-id="element-34" data-mp="yteimcuyu4qm">
                  Project Gallery
                </Link>
              </li>
              <li data-id="element-35" data-mp="18l2d6mmtk1wb">
                <Link to="/financing" className="hover:text-accent transition-colors" data-id="element-36" data-mp="18lk73cm0e412">
                  Financing
                </Link>
              </li>
              <li data-id="element-37" data-mp="1hium991y6db9">
                <Link to="/quote" className="hover:text-accent transition-colors" data-id="element-38" data-mp="1hmibhw0d0dk6">
                  Request a Free Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-39" data-mp="3oczqddx2sn7m">
            <h3 className="text-yellow-400 font-display font-semibold text-lg mb-6 uppercase tracking-wider" data-id="element-40" data-mp="3odhusxtw67qm">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-41" data-mp="2ag5ecolo18fl">
              <li className="flex items-start gap-3" data-id="element-42" data-mp="2agyg1b5rp7qv">
                <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-43" data-mp="25nlpuwlfwsw0" />
                <a href="tel:4075040596" className="hover:text-white transition-colors" data-id="element-44" data-mp="21maarl06zq22">
                  (407) 504-0596
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-45" data-mp="2te99ug8mr8yx">
                <Mail className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-46" data-mp="2tbn4mn97p5jv" />
                <a href="mailto:Info@theepinc.com" className="hover:text-white transition-colors" data-id="element-47" data-mp="2pcw8ojghftyc">
                  Info@theepinc.com
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-48" data-mp="2fgkpd9ih63ue">
                <Clock className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-49" data-mp="18yxmn6edva6n" />
                <div className="text-sm" data-id="element-50" data-mp="13yi9ofy0k4p7">
                  <p data-id="element-51" data-mp="13xgq1n2xm9vv">Mon-Fri: 9:00 AM - 5:00 PM</p>
                  <p data-id="element-52" data-mp="2rv7pfy9n201b">Sat-Sun: By Appointment</p>
                </div>
              </li>
            </ul>
            <Link to="/quote" className="mt-6 inline-block bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-sm text-sm font-semibold transition-colors" data-id="element-53" data-mp="2wmzj4ho3clvo">
              Request a Free Quote
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500" data-id="element-54" data-mp="3bk00br8noyfw">
          <p data-id="element-55" data-mp="3fk0lrvu6a9wg">
            Copyright © {new Date().getFullYear()} The Electrical Professionals
            Inc. All rights reserved. | Licensed & Insured Electrical Contractor
          </p>
          <div className="flex gap-6" data-id="element-56" data-mp="36jkkmt0wjeur">
            <span className="hover:text-slate-300 cursor-pointer transition-colors" data-id="element-57" data-mp="36mqa49dg0ir0">
              Privacy Policy
            </span>
            <span className="hover:text-slate-300 cursor-pointer transition-colors" data-id="element-58" data-mp="1v602cltdfiva">
              Terms of Service
            </span>
          </div>
        </div>

        <div className="pt-6 text-center" data-id="element-59" data-mp="1no24xfogry8f">
          <a href="https://www.websitesbymandy.com" target="_blank" rel="noopener noreferrer" className="text-[11px] text-slate-600 hover:text-slate-400 transition-colors" data-id="element-60" data-mp="1innyg22igwci">
            Made with a whole lot of grit by Trippin' With Mandy™ LLC
          </a>
        </div>
      </div>
    </footer>;
}